import { Box } from "@mui/material";

export const StatusBar = () => {
  return (
    <>
      {/* StatusBar visible */}
      <Box
        sx={{
          height: "env(safe-area-inset-top)",
          width: "100%",
          backgroundColor: "#000000",
          position: "fixed", // Se coloca en la parte superior sin afectar el flujo
          top: 0,
          left: 0,
          zIndex: 1300,
        }}
      />

      {/* Espaciador que empuja el contenido hacia abajo */}
      <Box sx={{ height: "env(safe-area-inset-top)" }} />
    </>
  );
};
